// 대화형 AI의 thread별 AI 분석 페이지
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { useCafRequestAnalysisComponentListV5 } from '../../../modules/apis/webview/caf'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_ai_speaking } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const CAFOverview = dynamic(() => import('../../new-portal/conversational-ai/CafOverviewBody'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const ConversationAnalysisActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const threadId = router.query?.threadId
  const { data: overallData, isLoading } = useCafRequestAnalysisComponentListV5(+threadId, true)

  const { useConversationAIFlow } = useConversationAIStack()
  const { push, pop } = useConversationAIFlow()
  const { t } = useTranslation()

  return (
    <WebviewStackContainer height="52px" border={true} onBack={pop} title={t(n_ai_speaking.ai_session.ai_analysis)}>
      <CAFOverview overallData={overallData} isLoading={isLoading} />
    </WebviewStackContainer>
  )
}

export default ConversationAnalysisActivity
